import Reflux from 'reflux';
import { fromJS } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import UserActions from 'flux/actions/UserActions';
import RealTimeActions from 'flux/actions/RealTimeActions';
import AlertActions from 'flux/actions/AlertActions';
import MessageConstants from 'shared/constants/Messages';
import UIRegions from 'shared/constants/UIRegions';
import EventCrewListActions from 'flux/actions/EventCrewListActions';
import IntercomActions from 'flux/actions/IntercomActions';
import RemoteTeleprompterActions from 'flux/actions/cuesheet.fullscreen/RemoteTeleprompterActions';

/**
 * UserSessionStore
 *
 *
 */
export default Reflux.createStore({
  listenables: [UserActions, RealTimeActions, EventCrewListActions],

  mixins: [BaseMixin],

  init() {
    this.setState(null);
  },

  onLoadFromSessionCompleted(user) {
    if (window.Intercom) {
      IntercomActions.boot({
        user_id: user._id,
        name: user.firstName + ' ' + user.lastName,
        email: user.email,
        created_at: user.createdOn,
      });
    }

    /**
     * Subscribe to realtime messages for user
     */
    RealTimeActions.subscribeToUser(user._id);

    RemoteTeleprompterActions.emitOperatorSettings({
      operator: `${user.firstName} ${user.lastName}`,
    });

    this.setStateAndTrigger(fromJS(user));
  },

  onUpdateFieldCompleted(user) {
    this.setStateAndTrigger(fromJS(user));
  },

  onUpdatePreferenceCompleted(user) {
    this.setStateAndTrigger(fromJS(user));
  },

  onUpdateOnboardingCompleted(user) {
    this.setStateAndTrigger(fromJS(user));
  },

  onUpdatePhotoCompleted(user) {
    this.setStateAndTrigger(fromJS(user));
  },

  onUpdateRole(teamId, eventId, userId, roleId, newRole) {
    this._updateEventRole(userId, eventId, newRole);
  },

  onEventUpdateRoleRealTime({ eventId }, { userId, role }) {
    this._updateEventRole(userId, eventId, role, true);
  },

  _updateEventRole(userId, eventId, role, notify) {
    if (userId !== this.getInState('_id')) return;

    let next = this.getState().update('events', (events) => {
      return events.map((event) => {
        if (event.get('event') !== eventId) return event;
        return event.set('role', role);
      });
    });

    this.setStateAndTrigger(next);

    if (!notify) return;

    AlertActions.show(
      MessageConstants.eventPermissionsChangedWarning,
      UIRegions.Cuesheet,
    );
  },
});
